import React, { useContext, useState } from "react";
import { ButtonProps, EditButton, Aside } from "sprint-common-web";

import { SeasonPageContext } from "../../context/SeasonPageContext";
import { EditSeasonForm, UpdatedSeasonData } from "../edit-season-form/EditSeasonForm";

export type EditSeasonButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    seasonId: string;
    isLabeled?: boolean;
    onClick?(): void;
};

export const EditSeasonButton: React.FunctionComponent<EditSeasonButtonProps> = (props: EditSeasonButtonProps) => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const seasonPageContext = useContext(SeasonPageContext);

    const handleClick = () => {
        setIsAsideOpen(true);
        if (props.onClick) {
            props.onClick();
        }
    };

    const handleEditSeasonFormSubmit = (updatedSeasonData: UpdatedSeasonData) => {
        seasonPageContext.updateSeason(updatedSeasonData);
        setIsAsideOpen(false);
    };

    const closeEditSeasonSidebar = () => {
        setIsAsideOpen(false);
    };

    return (
        <>
            <EditButton onClick={handleClick} isLabeled={props.isLabeled} testId="edit-season" />
            <Aside isOpen={isAsideOpen} type="form" headerText="Edit Season" onDismiss={closeEditSeasonSidebar}>
                <EditSeasonForm
                    onCancel={closeEditSeasonSidebar}
                    onSubmit={handleEditSeasonFormSubmit}
                    selectedSeasonId={props.seasonId ?? ""}
                />
            </Aside>
        </>
    );
};
